"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schedulingParamsFromCtx = exports.mergeAppointments = void 0;
/**
 * @param {Object} slot - an appointment returned from the `scheduling api`
 * @return {String}
 */
const keyFromAppointment = (slot) => [
    slot.start_datetime,
    slot.duration_minutes,
    slot.provider_id,
    slot.location_id
].join(':');
/**
 * Merge two lists of appointments and returns a list of
 * unique appointments
 * @param {Array} appointments
 * @param {Array} nextAppointments
 * @return {Array}
 */
const mergeAppointments = (availableSlots, nextAvailableSlot) => {
    const existing = new Set(availableSlots.map(keyFromAppointment));
    const uniq = nextAvailableSlot.filter((appt) => !existing.has(keyFromAppointment(appt)));
    return availableSlots.concat(uniq);
};
exports.mergeAppointments = mergeAppointments;
/**
 * Returns params used for the scheduling api call
 * @param {Object} ctx - machine context
 * @return {Object}
 */
const schedulingParamsFromCtx = (ctx, ev) => {
    return {
        provider: ctx.provider,
        location_ids: ctx.query.locationIds,
        period_start: ev.periodStart || ctx.query.periodStart || ctx.jumpedToDate || new Date(),
        purpose: ctx.query.purpose.name,
        patient_relationship: ctx.query.patientRel,
        role: ctx.query.role,
        visibility: ctx.query.visibility,
        pull_waitlist_eligibility: ctx.pull_waitlist_eligibility || false
    };
};
exports.schedulingParamsFromCtx = schedulingParamsFromCtx;
//# sourceMappingURL=apptTime.utils.js.map